import AlgoliaSearchSupport from 'algolia_search_support'
import { Controller } from '@hotwired/stimulus'
import { loadTemplate } from "utils/load_template"

export default class extends Controller {
  static targets = ["selectionText", "selectionInput"]

  initialize() {
    const search = new AlgoliaSearchSupport(
      ".search-input.casebook-request-form",
      this.suggestionTemplate,
      this.onAutocompleteSelected.bind(this),
      "content_type:'Casebooks'",
      { panel: "casebook-request-results"}
    )
    search.initialize()
  }

  clearSelection() {
    this.selectionTextTarget.textContent = "No casebook selected yet."
    this.selectionInputTarget.value = ""
    this.selectionTextTarget.classList.add("p-casebook-request_no-content")
  }

  suggestionTemplate(suggestion) {
    return loadTemplate('suggestion-template').interpolateObject(
      {
        title: suggestion._highlightResult.title.value,
        contentType: suggestion.subject || "",
        description: suggestion.description,
        videoIndicator: "",
        url: "#"
      }
    ).replaceAll("__aa-highlight__", "<span class='aa-highlight'>").replaceAll("__/aa-highlight__", "</span>")
  }

  onAutocompleteSelected(event) {
    const suggestion = event.item
    let normalizedId = suggestion.objectID

    normalizedId = parseInt(normalizedId.replace(/[^\d]/g, ""), 10)

    this.selectionInputTarget.value = normalizedId
    this.selectionTextTarget.textContent = suggestion.description
    this.selectionTextTarget.classList.remove("p-casebook-request_no-content")

    event.preventDefault()
  }
}
